import React, { useEffect } from 'react';
import { Header } from './Header';
import { ContactSection } from './ContactSection';
import { Footer } from './Footer';

export const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};
